// removed by extract-text-webpack-plugin
module.exports = {"categoryListItem":"CategorySidebar__categoryListItem___PgHSu","catagorySelectedItem":"CategorySidebar__catagorySelectedItem___3P40K"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/css/CategorySidebar.less
// module id = 90
// module chunks = 0 1